<template lang="html">
    <div class="container rock-climbing">
        <h2>Rock Climbing</h2>
        <div class="container">
            <p>
                These past couple of years I have been pushing my boundaries in the area of Trad Climbing. I find this activity much more intimidating than Sport Climbing and it really forces me to challenge myself mentally even more so than it does physically. Don't know what Trad Climbing is? Go here: <a href="http://outdoors.stackexchange.com/questions/4635/whats-the-difference-between-sport-climbing-and-traditional-climbing">Trad vs Sport Climbing.</a>
            </p>
            <p>
                Some of my favorite places to climb have been <a href="http://www.climbing.com/places/the-gunks-new-york-climbing-destination-guide/">The Gunks</a> in NY, the <a href="https://www.mountainproject.com/v/st-vrain-canyons/107839313">St. Vrain Canyon</a> in CO, and <a href="https://www.mountainproject.com/v/grand-teton/105803123">The Tetons</a> in WY.
            </p>
            <p>
                The Adobe Spark site I built to tell the story of my father and I attempting to summit the Grand Teton via the Exum Ridge in July 2016 can be found here: <a href="https://spark.adobe.com/page/rmnfS/">Full Exum Attempt, all photos taken by Adam's iPhone 5S.</a> Once I have finished a few other personal projects I have been working on I will go back and rebuild the site without Adobe to improve its responsiveness.
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'RockClimbing'
    };

</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/interests/hobbies/rock-climbing.vue